import { Fragment, jsx, jsxs } from "react/jsx-runtime";
import { c } from "react-compiler-runtime";
import { useEffect, useState } from "react";
import { TreeItem2 } from "@mui/x-tree-view/TreeItem2";
import classnames from "classnames";
import { ColoredChip } from "../ColoredChip/index.js";
import { Icon } from "../Icon/index.js";
import { EllipsisText } from "../EllipsisText/index.js";
import { Box } from "../Box/index.js";
import { CircularProgress } from "../CircularProgress/index.js";
import { Callout } from "../Callout/index.js";
import { Checkbox } from "../Checkbox/index.js";
import { useStyles } from "./TreeItem.styles.js";
function _define_property(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if ("function" == typeof Object.getOwnPropertySymbols) ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function TreeItem_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = null != source ? source : {};
    if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    else TreeItem_ownKeys(Object(source)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
    return target;
}
function _object_without_properties(source, excluded) {
    if (null == source) return {};
    var target = {}, sourceKeys, key, i;
    if ("u" > typeof Reflect && Reflect.ownKeys) {
        sourceKeys = Reflect.ownKeys(Object(source));
        for(i = 0; i < sourceKeys.length; i++){
            key = sourceKeys[i];
            if (!(excluded.indexOf(key) >= 0)) {
                if (Object.prototype.propertyIsEnumerable.call(source, key)) target[key] = source[key];
            }
        }
        return target;
    }
    target = _object_without_properties_loose(source, excluded);
    if (Object.getOwnPropertySymbols) {
        sourceKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceKeys.length; i++){
            key = sourceKeys[i];
            if (!(excluded.indexOf(key) >= 0)) {
                if (Object.prototype.propertyIsEnumerable.call(source, key)) target[key] = source[key];
            }
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (null == source) return {};
    var target = {}, sourceKeys = Object.getOwnPropertyNames(source), key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (!(excluded.indexOf(key) >= 0)) {
            if (Object.prototype.propertyIsEnumerable.call(source, key)) target[key] = source[key];
        }
    }
    return target;
}
const TreeItem = (props)=>{
    var _item_children, _item_children1;
    const $ = c(105);
    const { item, showRulers: t0, showCounters: t1, expanded, onSelect, onExpand, onChildrenLoad, renderOption } = props;
    const showRulers = void 0 === t0 ? true : t0;
    const showCounters = void 0 === t1 ? true : t1;
    let t2;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = [];
        $[0] = t2;
    } else t2 = $[0];
    const [loadedChildren, setLoadedChildren] = useState(t2);
    const [isLoading, setIsLoading] = useState(false);
    const [isError, setIsError] = useState(false);
    let t3;
    if ($[1] !== expanded || $[2] !== item.id) {
        t3 = null == expanded ? void 0 : expanded.some((expandedItems)=>expandedItems === item.id);
        $[1] = expanded;
        $[2] = item.id;
        $[3] = t3;
    } else t3 = $[3];
    const isExpanded = t3;
    const { classes: rawClasses } = useStyles();
    let classes;
    let groupTransition;
    let itemCounter;
    let label;
    if ($[4] !== rawClasses) {
        const { itemLabel, itemCounter: t4, groupTransition: t5, label: t6 } = rawClasses, t7 = _object_without_properties(rawClasses, [
            "itemLabel",
            "itemCounter",
            "groupTransition",
            "label"
        ]);
        itemCounter = t4;
        groupTransition = t5;
        label = t6;
        classes = t7;
        $[4] = rawClasses;
        $[5] = classes;
        $[6] = groupTransition;
        $[7] = itemCounter;
        $[8] = label;
    } else {
        classes = $[5];
        groupTransition = $[6];
        itemCounter = $[7];
        label = $[8];
    }
    let t4;
    if ($[9] !== isExpanded || $[10] !== (null == (_item_children = item.children) ? void 0 : _item_children.length) || $[11] !== item.hasChildrenToLoad || $[12] !== item.id || $[13] !== loadedChildren.length || $[14] !== onChildrenLoad) {
        var _item_children2;
        t4 = ()=>{
            var _item_children;
            if (isExpanded && item.hasChildrenToLoad && !(null == (_item_children = item.children) ? void 0 : _item_children.length) && !loadedChildren.length) {
                setIsLoading(true);
                setIsError(false);
                null == onChildrenLoad || onChildrenLoad(item.id).then((result)=>{
                    setIsLoading(false);
                    setLoadedChildren(result);
                }).catch(()=>{
                    setIsLoading(false);
                    setIsError(true);
                    setLoadedChildren([]);
                });
            }
        };
        $[9] = isExpanded;
        $[10] = null == (_item_children2 = item.children) ? void 0 : _item_children2.length;
        $[11] = item.hasChildrenToLoad;
        $[12] = item.id;
        $[13] = loadedChildren.length;
        $[14] = onChildrenLoad;
        $[15] = t4;
    } else t4 = $[15];
    const t5 = null == (_item_children1 = item.children) ? void 0 : _item_children1.length;
    let t6;
    if ($[16] !== isExpanded || $[17] !== item || $[18] !== loadedChildren.length || $[19] !== onChildrenLoad || $[20] !== t5) {
        t6 = [
            isExpanded,
            t5,
            item.hasChildrenToLoad,
            item.id,
            loadedChildren.length,
            onChildrenLoad,
            item
        ];
        $[16] = isExpanded;
        $[17] = item;
        $[18] = loadedChildren.length;
        $[19] = onChildrenLoad;
        $[20] = t5;
        $[21] = t6;
    } else t6 = $[21];
    useEffect(t4, t6);
    let t7;
    if ($[22] !== item || $[23] !== onSelect) {
        t7 = (event)=>{
            event.preventDefault();
            event.stopPropagation();
            if (item.disabled) return;
            onSelect(item.id, item.label, item);
        };
        $[22] = item;
        $[23] = onSelect;
        $[24] = t7;
    } else t7 = $[24];
    const handleLabelClick = t7;
    let t8;
    if ($[25] !== item.id || $[26] !== onExpand) {
        t8 = (event_0)=>{
            event_0.preventDefault();
            event_0.stopPropagation();
            onExpand(item.id);
        };
        $[25] = item.id;
        $[26] = onExpand;
        $[27] = t8;
    } else t8 = $[27];
    const handleIconClick = t8;
    let T0;
    let childrenToShow;
    let isShowChildren;
    let t10;
    let t11;
    let t12;
    let t13;
    let t14;
    let t9;
    if ($[28] !== classes || $[29] !== groupTransition || $[30] !== handleIconClick || $[31] !== handleLabelClick || $[32] !== item || $[33] !== label || $[34] !== loadedChildren || $[35] !== props.multiple || $[36] !== props.selected || $[37] !== rawClasses.itemDisabled || $[38] !== rawClasses.itemLabel || $[39] !== renderOption || $[40] !== showRulers) {
        const getIsIndeterminate = (value, option)=>{
            if (!value.includes(option.id)) return false;
            if (!option.children) return false;
            if (!option.children.every((child_0)=>value.includes(child_0.id))) return true;
            return option.children.every((child)=>getIsIndeterminate(value, child));
        };
        childrenToShow = (null == item ? void 0 : item.children) && !!item.children.length ? item.children : loadedChildren;
        isShowChildren = !!childrenToShow.length || item.hasChildrenToLoad;
        let t15;
        if ($[50] !== item || $[51] !== renderOption) {
            t15 = renderOption ? renderOption(item) : /*#__PURE__*/ jsx(EllipsisText, {
                wordBreak: "break-all",
                children: item.label
            });
            $[50] = item;
            $[51] = renderOption;
            $[52] = t15;
        } else t15 = $[52];
        const labelContent = t15;
        T0 = TreeItem2;
        t11 = item.id;
        let t16;
        if ($[53] !== groupTransition || $[54] !== showRulers) {
            t16 = showRulers ? {
                groupTransition
            } : {};
            $[53] = groupTransition;
            $[54] = showRulers;
            $[55] = t16;
        } else t16 = $[55];
        let t17;
        if ($[56] !== label) {
            t17 = classnames(label, "aqa_tree_item");
            $[56] = label;
            $[57] = t17;
        } else t17 = $[57];
        if ($[58] !== classes || $[59] !== t16 || $[60] !== t17) {
            t12 = _object_spread_props(_object_spread({}, classes, t16), {
                label: t17
            });
            $[58] = classes;
            $[59] = t16;
            $[60] = t17;
            $[61] = t12;
        } else t12 = $[61];
        let t18;
        if ($[62] !== handleLabelClick) {
            t18 = {
                onClick: (event_1)=>handleLabelClick(event_1)
            };
            $[62] = handleLabelClick;
            $[63] = t18;
        } else t18 = $[63];
        let t19;
        if ($[64] !== handleIconClick) {
            t19 = {
                onClick: (event_2)=>handleIconClick(event_2)
            };
            $[64] = handleIconClick;
            $[65] = t19;
        } else t19 = $[65];
        if ($[66] !== t18 || $[67] !== t19) {
            t13 = {
                label: t18,
                iconContainer: t19
            };
            $[66] = t18;
            $[67] = t19;
            $[68] = t13;
        } else t13 = $[68];
        t14 = "tree-item-root-test-id";
        t9 = item.disabled ? rawClasses.itemDisabled : rawClasses.itemLabel;
        t10 = props.multiple ? /*#__PURE__*/ jsxs(Box, {
            display: "flex",
            alignItems: "center",
            gap: "8",
            children: [
                /*#__PURE__*/ jsx(Checkbox, {
                    checked: props.selected.includes(item.id),
                    indeterminate: getIsIndeterminate(props.selected, item),
                    disabled: item.disabled
                }),
                labelContent
            ]
        }) : labelContent;
        $[28] = classes;
        $[29] = groupTransition;
        $[30] = handleIconClick;
        $[31] = handleLabelClick;
        $[32] = item;
        $[33] = label;
        $[34] = loadedChildren;
        $[35] = props.multiple;
        $[36] = props.selected;
        $[37] = rawClasses.itemDisabled;
        $[38] = rawClasses.itemLabel;
        $[39] = renderOption;
        $[40] = showRulers;
        $[41] = T0;
        $[42] = childrenToShow;
        $[43] = isShowChildren;
        $[44] = t10;
        $[45] = t11;
        $[46] = t12;
        $[47] = t13;
        $[48] = t14;
        $[49] = t9;
    } else {
        T0 = $[41];
        childrenToShow = $[42];
        isShowChildren = $[43];
        t10 = $[44];
        t11 = $[45];
        t12 = $[46];
        t13 = $[47];
        t14 = $[48];
        t9 = $[49];
    }
    let t15;
    if ($[69] !== item.hasSeparateAbove || $[70] !== item.isSeparate) {
        t15 = item.isSeparate && !item.hasSeparateAbove && /*#__PURE__*/ jsx(ColoredChip, {
            startIcon: /*#__PURE__*/ jsx(Icon, {
                name: "vkhrtek_separate_unit",
                color: "text.light.tertirary",
                size: "12"
            }),
            size: "extraSmall",
            color: "darkgray"
        });
        $[69] = item.hasSeparateAbove;
        $[70] = item.isSeparate;
        $[71] = t15;
    } else t15 = $[71];
    let t16;
    if ($[72] !== item.count || $[73] !== itemCounter || $[74] !== showCounters) {
        t16 = showCounters && Number.isInteger(item.count) && /*#__PURE__*/ jsx("div", {
            className: itemCounter,
            children: item.count
        });
        $[72] = item.count;
        $[73] = itemCounter;
        $[74] = showCounters;
        $[75] = t16;
    } else t16 = $[75];
    let t17;
    if ($[76] !== t15 || $[77] !== t16) {
        t17 = /*#__PURE__*/ jsxs(Box, {
            display: "flex",
            gap: "8",
            children: [
                t15,
                t16
            ]
        });
        $[76] = t15;
        $[77] = t16;
        $[78] = t17;
    } else t17 = $[78];
    let t18;
    if ($[79] !== t10 || $[80] !== t17 || $[81] !== t9) {
        t18 = /*#__PURE__*/ jsxs("div", {
            className: t9,
            children: [
                t10,
                t17
            ]
        });
        $[79] = t10;
        $[80] = t17;
        $[81] = t9;
        $[82] = t18;
    } else t18 = $[82];
    let t19;
    if ($[83] !== childrenToShow || $[84] !== expanded || $[85] !== isError || $[86] !== isLoading || $[87] !== isShowChildren || $[88] !== onChildrenLoad || $[89] !== onExpand || $[90] !== onSelect || $[91] !== props.multiple || $[92] !== props.selected || $[93] !== renderOption || $[94] !== showCounters || $[95] !== showRulers) {
        t19 = isShowChildren && /*#__PURE__*/ jsxs(Fragment, {
            children: [
                childrenToShow && childrenToShow.map((child_1)=>/*#__PURE__*/ jsx(TreeItem, _object_spread({
                        item: child_1,
                        showRulers: showRulers,
                        showCounters: showCounters,
                        onSelect: onSelect,
                        onExpand: onExpand,
                        onChildrenLoad: onChildrenLoad,
                        expanded: expanded,
                        renderOption: renderOption
                    }, props.multiple ? {
                        multiple: props.multiple,
                        selected: props.selected
                    } : {
                        selected: props.selected
                    }), child_1.id)),
                isLoading && /*#__PURE__*/ jsx(Box, {
                    display: "flex",
                    justifyContent: "center",
                    py: "16",
                    "data-testid": "circular-progress-loader-test-id",
                    children: /*#__PURE__*/ jsx(CircularProgress, {
                        size: 20
                    })
                }),
                isError && /*#__PURE__*/ jsx(Box, {
                    py: "24",
                    px: "16",
                    children: /*#__PURE__*/ jsx(Callout, {
                        variant: "error",
                        showIcon: true,
                        children: "Не удалось загрузить оргструктуру. Обновите страницу и попробуйте еще раз"
                    })
                })
            ]
        });
        $[83] = childrenToShow;
        $[84] = expanded;
        $[85] = isError;
        $[86] = isLoading;
        $[87] = isShowChildren;
        $[88] = onChildrenLoad;
        $[89] = onExpand;
        $[90] = onSelect;
        $[91] = props.multiple;
        $[92] = props.selected;
        $[93] = renderOption;
        $[94] = showCounters;
        $[95] = showRulers;
        $[96] = t19;
    } else t19 = $[96];
    let t20;
    if ($[97] !== T0 || $[98] !== t11 || $[99] !== t12 || $[100] !== t13 || $[101] !== t14 || $[102] !== t18 || $[103] !== t19) {
        t20 = /*#__PURE__*/ jsx(T0, {
            itemId: t11,
            classes: t12,
            slotProps: t13,
            "data-testid": t14,
            label: t18,
            children: t19
        });
        $[97] = T0;
        $[98] = t11;
        $[99] = t12;
        $[100] = t13;
        $[101] = t14;
        $[102] = t18;
        $[103] = t19;
        $[104] = t20;
    } else t20 = $[104];
    return t20;
};
export { TreeItem };
